<template>
  <div class="host">
    <input
      ref="fileInput"
      id="input-upload"
      type="file"
      @change="selectImage"
      accept=".jpg, .jpeg, .png, .svg, .gif"
    />
    <div class="logo-wrap">
      <div v-if="img && !loading" class="remove-button-wrap">
        <button @click="$emit('remove')" type="button" class="remove-button">
          <i class="material-icons">close</i>
        </button>
      </div>
      <label for="input-upload" class="logo">
        <div v-if="img" class="image-background" :style="{ backgroundImage: `url(${img})` }"></div>
        <!-- <img v-if="img" :src="img" alt="logo" /> -->
        <div v-else class="logo-placeholder">
          <img class="placeholder" src="@/assets/user.svg" alt="Аватар">
          <!-- <UploadIcon /> -->
          <!-- <span class="subtext">Логотип</span> -->
        </div>
        <div class="vm-overlay">
          <i class="material-icons">cloud_upload</i>
        </div>
      </label>
      <div v-if="loading" class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    loading: {
      type: Boolean,
      value: false
    }
  },
  methods: {
    selectImage(event) {
      const files = event.target.files || event.dataTransfer.files;
      const file = files[0];
      this.$emit('upload', file);
      this.$refs.fileInput.value = '';
    }
  }
};
</script>

<style lang="scss" scoped>
#input-upload {
  display: none;
}
.logo {
  position: relative;
  background: #fff;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 10px 4px rgba(0,0,0,.01);
}
.logo img {
  max-width: 100%;
  max-height: 100%;
}
.logo .logo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo .vm-overlay {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 300ms ease;
}
.logo:hover .vm-overlay {
  top: 50%;
}
.logo .vm-overlay i {
  font-size: 24px;
  color: #fff;
}
.logo svg {
  fill: #fff;
  width: 50px;
}
.logo .subtext {
  color: #fff;
  font-weight: 600;
}
.logo-wrap {
  position: relative;
}
.remove-button-wrap {
  position: absolute;
  background: rgb(241, 241, 241);
  height: 30px;
  width: 30px;
  border-radius: 50%;
  top: 10px;
  left: 10px;
  outline: 0;
  z-index: 3;
}
.remove-button {
  align-items: center;
  display: flex;
  justify-content: center;
  background: rgba(255, 106, 106, 1);
  position: absolute;
  bottom: 5px;
  right: 5px;
  border: none;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  outline: 0;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}
.remove-button:hover {
  background: rgba(255, 106, 106, 0.8);
}
.remove-button i {
  font-size: 14px;
  // color: #717171;
  color: #fff;
}
.logo-placeholder {
  width: 100px;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 160px;
  height: 160px;
}
$loader-width: 6px;
.loader {
  background-color: rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 10px;
  position: absolute;
  top: 0;
  text-indent: -9999em;
  border-top: $loader-width solid rgba(255, 255, 255, 0.2);
  border-right: $loader-width solid rgba(255, 255, 255, 0.2);
  border-bottom: $loader-width solid rgba(255, 255, 255, 0.2);
  border-left: $loader-width solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  z-index: 2;
}
.image-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-size: cover;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
